import React, { createContext, useContext } from 'react';

export interface HilFormContentProps {
  formID: number;
  prePopulate: Record<string, unknown>;
  onValuesChange: (values: Record<string, unknown>) => void;
  disabled?: boolean;
}

export type HilFormContentRenderer = (props: HilFormContentProps) => React.ReactNode;

const HilFormRendererContext = createContext<HilFormContentRenderer | null>(null);

export function useHilFormRenderer(): HilFormContentRenderer | null {
  return useContext(HilFormRendererContext);
}

export const HilFormRendererProvider = HilFormRendererContext.Provider;
